/*
 * File: rootReducer.ts
 * Project: receiving-rules
 * -----
 * Last Modified: 30 Sep 2020 4:55:14 pm
 * -----
 * Copyright (c) 2020 Elegant Software Solutions All rights reserved.
 */

import { combineReducers } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { appApi } from 'redux/services/useAbbyCadabbyService';
import { buyerApi, customerApi } from 'redux/services/useBeautifylDayMonsterService';
import { deliveryApi } from 'redux/services/useGladysTheCowService';
import { salesOrderTypesApi } from 'redux/services/useGrannyFannyNesselrodeService';
import { warehouseSiteApi } from 'redux/services/useKingstonLivingstonService';
import { salespersonApi } from 'redux/services/useLeftyTheSalesmanService';
import { salesOrderApi } from 'redux/services/useMamaBearService';
import { appReducer } from './app/app-slice';
import { customerCachingSlice } from './customerCachingSlice/customerCachingSlice';
import { bulkApplySlice } from './productsInfo/bulkApplySlice';
import { productsInfo } from './productsInfo/productsInfoSlice';
import { customerSelectionFiltersSlice } from './salesOrder/customerSelectionFiltersSlice';
import { ordersReducer } from './salesOrder/ordersSlice';
import { salesOrderDraftIdSlice } from './salesOrder/salesOrderDraftIdSlice';
import { selectedSalesOrdersSlice } from './salesOrder/selectedSalesOrdersSlice';
import { ocdApi } from './services/useAnimalService';
import { deliveryAddressApi } from './services/useBusterTheHorseService';
import { worldsApi } from './services/useChuckieSueService';
import { userApi } from './services/useCookieMonster';
import { productsApi } from './services/useDonaldGrumpService';
import { floBearApi } from './services/useFloBearApi';
import { applicationApi } from './services/useFreddyCadabbyServices';
import { legalEntitiesApi } from './services/useMaggieCadabbyService';
import { vendorsApi } from './services/useSimonSoundman';


const persistConfig = { key: 'root', storage, version: 1 };

const persistedReducer = persistReducer(persistConfig, customerCachingSlice.reducer);

const reducers = {
  app: appReducer,
  salesOrders: ordersReducer,
  productsInfo: productsInfo.reducer,
  [customerSelectionFiltersSlice.name]: customerSelectionFiltersSlice.reducer,
  [selectedSalesOrdersSlice.name]: selectedSalesOrdersSlice.reducer,
  [customerCachingSlice.name]: persistedReducer,
  [bulkApplySlice.name]: bulkApplySlice.reducer,
  [salesOrderDraftIdSlice.name]: salesOrderDraftIdSlice.reducer,
  [appApi.reducerPath]: appApi.reducer,
  [applicationApi.reducerPath]: applicationApi.reducer,
  [customerApi.reducerPath]: customerApi.reducer,
  [buyerApi.reducerPath]: buyerApi.reducer,
  [productsApi.reducerPath]: productsApi.reducer,
  [ocdApi.reducerPath]: ocdApi.reducer,
  [deliveryApi.reducerPath]: deliveryApi.reducer,
  [salesOrderApi.reducerPath]: salesOrderApi.reducer,
  [salesOrderTypesApi.reducerPath]: salesOrderTypesApi.reducer,
  [salespersonApi.reducerPath]: salespersonApi.reducer,
  [warehouseSiteApi.reducerPath]: warehouseSiteApi.reducer,
  [deliveryAddressApi.reducerPath]: deliveryAddressApi.reducer,
  [vendorsApi.reducerPath]: vendorsApi.reducer,
  [worldsApi.reducerPath]: worldsApi.reducer,
  [userApi.reducerPath]: userApi.reducer,
  [legalEntitiesApi.reducerPath]: legalEntitiesApi.reducer,
  [floBearApi.reducerPath]: floBearApi.reducer
};

const rootReducer = combineReducers(reducers);

export type ReduxState = ReturnType<typeof rootReducer>;

export default rootReducer;
